import { css } from '@linaria/core';
export const avatarImageWrapper = "omponents__Avatar__Avatar_styles_ts-avatarImageWrapper-a1kxc3vi";

require("./Avatar_styles.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./Avatar_styles.ts");